module.exports = __webpack_public_path__ + "static/media/rider.66b5af67.svg";